import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import _ from "lodash";

const HostList = ({ status }) => {
  const baseUrl = process.env.REACT_APP_BASEURL2;
  const [AgencyList, setAgencyList] = useState([]);
  const [reload, setReload] = useState(false);
  const [limit, setLimit] = useState(50);
  const [count, setCount] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  const { totalHosts, totalPages, page, setPage } = useContext(global);
  const agency = sessionStorage.getItem("agency");
  const newAgency = JSON.parse(agency);
  const agencysqlId = newAgency?.sqlId;
  const agencyuniqueId = newAgency?.uniqueId;

  let id;
  let idd;
  if (newAgency?.old == "1") {
    id = newAgency?.sqlId;
    idd = newAgency?.uniqueId;
  } else {
    id = newAgency?.uniqueId;
    idd = newAgency?.sqlId;
  }

  const aglist1 = async () => {
    try {
      setAgencyList([]);
      const response = await axios.get(`${baseUrl}/agency/host/findpanhost`, {
        params: { uniqueId: id, uniqueIdd: idd, status, page, limit },
      });
      setAgencyList(response.data.details);
      setCount(response.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const searchHosts = async (query) => {
    try {
      setAgencyList([]);
      const response = await axios.get(`${baseUrl}/agency/host/searchhost`, {
        params: { uniqueId: id, uniqueIdd: idd, status, searchQuery: query },
      });
      setAgencyList(response.data.details);
      setCount(response.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    aglist1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, reload, page, limit]);

  const aglist = async (status, id) => {
    try {
      const response = await axios.get(`${baseUrl}/agency/host/hostrequestsent`, {
        params: { id, status },
      });
      if (response.data.success === 1) toast.success(response.data.message);
      else toast.error(response.data.message);
      setReload(!reload);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearchChange = useCallback((value) => setSearchQuery(value), []);
  const handleGoClick = () => {
    if (searchQuery.trim()) searchHosts(searchQuery.trim());
    else aglist1();
  };

  // Styles
  const cardStyle = {
    border: "1px solid #eaeef5",
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(17, 24, 39, 0.08)",
    overflow: "hidden",
    background: "#fff",
    animation: "fadeSlideIn 500ms ease-out",
  };
  const headerWrap = {
    background:
      "linear-gradient(135deg, rgba(52,152,219,1) 0%, rgba(96,92,168,1) 100%)",
    borderRadius: 16,
    padding: "18px 22px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 10px 25px rgba(52,152,219,0.35)",
  };
  const smallBadge = {
    background: "rgba(255,255,255,0.15)",
    border: "1px solid rgba(255,255,255,0.35)",
    padding: "6px 10px",
    backdropFilter: "blur(6px)",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
  };
  const selectStyle = {
    borderRadius: 12,
    border: "2px solid #ecf3fb",
    padding: "10px 14px",
    fontSize: 14,
    transition: "all 0.25s ease",
    backgroundColor: "#ffffff",
    color: "#2c3e50",
    outline: "none",
  };
  const inputStyle = {
    width: "100%",
    minWidth: 0,
    border: "2px solid #ecf3fb",
    borderRight: "none",
    padding: "11px 14px",
    fontSize: 14,
    outline: "none",
    background: "#fff",
    color: "#0f172a",
    borderRadius: "12px 0 0 12px",
  };
  const goBtn = {
    border: "2px solid #3498db",
    background: "#3498db",
    color: "#fff",
    fontWeight: 700,
    padding: "0 18px",
    fontSize: 14,
    letterSpacing: 0.6,
    cursor: "pointer",
    borderRadius: "0 12px 12px 0",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 44,
    whiteSpace: "nowrap",
    transition: "transform .2s ease, box-shadow .2s ease, background .2s ease",
    boxShadow: "0 6px 16px rgba(52,152,219,0.25)",
  };
  const tableWrap = { borderRadius: 14, overflow: "hidden", border: "1px solid #eef2f7" };
  const theadStyle = { background: "#f8fafc" };
  const thStyle = {
    fontWeight: 700,
    color: "#334155",
    fontSize: 13,
    letterSpacing: 0.2,
    padding: "12px 10px",
    borderBottom: "1px solid #e9eef5",
    whiteSpace: "nowrap",
  };
  const tdStyle = {
    padding: "12px 10px",
    fontSize: 13,
    color: "#1f2937",
    verticalAlign: "middle",
    borderBottom: "1px solid #f1f5f9",
  };
  const pill = (bg, color = "#fff") => ({
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    background: bg,
    color,
    letterSpacing: 0.2,
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  });
  const dropdownBtn = {
    backgroundColor: "#f7f9fc",
    color: "#0f172a",
    border: "1px solid #e6eef7",
    borderRadius: 10,
    padding: "8px 12px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all .2s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  };
  const pagerBtn = (disabled) => ({
    background: disabled ? "#e8eef6" : "#111827",
    color: disabled ? "#7b8794" : "#fff",
    border: "1px solid",
    borderColor: disabled ? "#e8eef6" : "#111827",
    borderRadius: 10,
    padding: "10px 14px",
    margin: "0 6px",
    fontSize: 13,
    fontWeight: 700,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.7 : 1,
    transition: "transform .15s ease, box-shadow .15s ease",
    boxShadow: disabled ? "none" : "0 8px 18px rgba(17,24,39,0.18)",
  });

  return (
    <>
      {/* Keyframes + responsive search bar */}
      <style>{`
        @keyframes fadeSlideIn{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}
        @keyframes pulseSoft{0%{transform:scale(1)}50%{transform:scale(1.02)}100%{transform:scale(1)}}
        .table-row-hover:hover{background:#f9fbff!important;transform:translateY(-1px);box-shadow:inset 0 0 0 9999px rgba(52,152,219,0.03)}
        .searchBar{display:grid;grid-template-columns:1fr auto;column-gap:8px;align-items:stretch;border-radius:12px;overflow:hidden;box-shadow:0 6px 14px rgba(2,8,23,0.06)}
        .searchBar input{height:44px}
        .searchBar button{height:44px}
        @media(max-width:768px){
          .searchBar{grid-template-columns:1fr;row-gap:8px;box-shadow:none}
          .searchBar input{border-radius:12px;border-right:2px solid #ecf3fb!important}
          .searchBar button{width:100%;border-radius:12px}
        }
      `}</style>

      <section className="content-header" style={{ marginBottom: 8 }}>
        <div style={headerWrap}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 42, height: 42, borderRadius: 12,
                background: "rgba(255,255,255,0.2)",
                display: "grid", placeItems: "center",
                fontSize: 18, fontWeight: 800,
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.4)",
              }}
            >
              HL
            </div>
            <div>
              <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, letterSpacing: 0.3 }}>
                Host List
              </h1>
              <div style={{ marginTop: 4, fontSize: 12, opacity: 0.9 }}>
                Manage and review host onboarding status
              </div>
            </div>
          </div>
          <div style={smallBadge}>{typeof count === "number" ? `Total: ${count}` : "Loading..."}</div>
        </div>

        <ol className="breadcrumb" style={{ background: "transparent", marginTop: 10, padding: 0, display: "flex", gap: 6 }}>
          <li>
            <Link to="/admin" style={{ color: "#475569", fontWeight: 600 }}>
              <i className="fa fa-dashboard" /> Home
            </Link>
          </li>
          <li className="active" style={{ color: "#111827", fontWeight: 700 }}>Host List</li>
        </ol>
      </section>

      <section className="content" style={{ animation: "fadeSlideIn 420ms ease-out" }}>
        <div className="row" style={{ margin: 0 }}>
          <div className="col-xs-12" style={{ padding: 0 }}>
            <div className="box" style={cardStyle}>
              <div className="box-body" style={{ padding: 18 }}>
                {/* Controls */}
                <div className="row" style={{ marginBottom: 16, display: "flex", alignItems: "flex-end", gap: 12 }}>
                  <div className="form-group col-xs-12 col-sm-6" style={{ marginBottom: 12 }}>
                    <label htmlFor="limit" style={{ fontWeight: 800, color: "#0f172a", fontSize: 12, marginBottom: 8, display: "block", letterSpacing: 0.3, textTransform: "uppercase" }}>
                      Results per page
                    </label>
                    <select
                      id="limit"
                      value={limit}
                      onChange={(e) => setLimit(Number(e.target.value))}
                      className="form-control"
                      style={selectStyle}
                      onFocus={(e) => (e.target.style.borderColor = "#3498db")}
                      onBlur={(e) => (e.target.style.borderColor = "#ecf3fb")}
                    >
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                    </select>
                  </div>

                  {/* <div className="form-group col-xs-12 col-sm-4" style={{ marginBottom: 12 }} /> */}

                  <div className="form-group col-xs-12 col-sm-6" style={{ marginBottom: 12 }}>
                    <label htmlFor="search" style={{ fontWeight: 800, color: "#0f172a", fontSize: 12, marginBottom: 8, display: "block", letterSpacing: 0.3, textTransform: "uppercase" }}>
                      Search by Username
                    </label>

                    {/* Responsive search bar */}
                    <div className="searchBar">
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        placeholder="Enter username to search..."
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleGoClick()}
                        style={inputStyle}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3498db";
                          e.target.style.boxShadow = "inset 0 0 0 1px rgba(52,152,219,0.25)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#ecf3fb";
                          e.target.style.boxShadow = "none";
                        }}
                      />
                      <button
                        onClick={handleGoClick}
                        style={goBtn}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 10px 22px rgba(52,152,219,0.35)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 6px 16px rgba(52,152,219,0.25)";
                        }}
                        title="Search"
                      >
                        <i className="fa fa-search" style={{ marginRight: 6 }} />
                        GO
                      </button>
                    </div>

                    {searchQuery && (
                      <div style={{ marginTop: 8, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <small style={{ color: "#64748b", fontSize: 12 }}>
                          Searching for: <strong style={{ color: "#0f172a" }}>"{searchQuery}"</strong>
                        </small>
                        <button
                          onClick={() => {
                            setSearchQuery("");
                            aglist1();
                          }}
                          style={{ background: "none", border: "none", color: "#e11d48", cursor: "pointer", fontSize: 12, textDecoration: "underline", padding: "2px 6px", fontWeight: 700 }}
                          title="Clear search"
                        >
                          Clear Search
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Table */}
                <div style={tableWrap}>
                  <table id="example1" className="table table-bordered table-striped" style={{ margin: 0, width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
                    <thead style={theadStyle}>
                      <tr>
                        {["Sr.", "Date", "Username", "Name", "Agency Code", "Status", "Action"].map((h) => (
                          <th key={h} style={thStyle}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody id="ts">
                      {AgencyList.length === 0 ? (
                        <tr>
                          <td colSpan={7} style={{ ...tdStyle, textAlign: "center", color: "#64748b" }}>
                            No data available
                          </td>
                        </tr>
                      ) : (
                        AgencyList.map((host, i) => (
                          <tr key={host._id} className="table-row-hover" style={{ background: i % 2 === 0 ? "#ffffff" : "#fbfdff", transition: "all .2s ease" }}>
                            <td style={tdStyle}>{count - limit * (page - 1) - i}</td>
                            <td style={tdStyle}>{new Date(host?.updatedAt).toLocaleString()}</td>
                            <td style={tdStyle}>{host?.username}</td>
                            <td style={tdStyle}>{host?.realName}</td>
                            <td style={tdStyle}>{newAgency.uniqueId}</td>
                            <td style={tdStyle}>
                              <span
                                className={`label ${
                                  host.status == 0
                                    ? "label-info"
                                    : host.status == 1
                                    ? "label-success"
                                    : host.status == 3
                                    ? "label-primary"
                                    : host.status == 4
                                    ? "label-primary"
                                    : "label-danger"
                                }`}
                                style={
                                  host.status == 0
                                    ? pill("#38bdf8")
                                    : host.status == 1
                                    ? pill("#22c55e")
                                    : host.status == 3
                                    ? pill("#818cf8")
                                    : host.status == 4
                                    ? pill("#6366f1")
                                    : pill("#ef4444")
                                }
                              >
                                {host.status == 0
                                  ? "Pending"
                                  : host.status == 1
                                  ? "Approved"
                                  : host.status == 3
                                  ? "Pending by Agency Admin"
                                  : host.status == 4
                                  ? "Pending by Bd"
                                  : "Rejected"}
                              </span>
                            </td>
                            <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>
                              <ul className="admin-action btn btn-default" style={{ ...dropdownBtn, listStyle: "none", margin: 0 }}>
                                <li className="dropdown" style={{ listStyle: "none" }}>
                                  <a className="dropdown-toggle" style={{ color: "#0f172a", textDecoration: "none" }} data-toggle="dropdown" href="#" aria-expanded="false">
                                    Action  
                                  </a>
                                  <ul className="dropdown-menu dropdown-menu-right" style={{ minWidth: 160, borderRadius: 12, border: "1px solid #eaeef5", boxShadow: "0 10px 24px rgba(2,8,23,0.12)", padding: 6 }}>
                                    {host.status === "0" ? (
                                      <>
                                        <li role="presentation" onClick={() => aglist("1", host._id)} style={{ borderRadius: 8 }}>
                                          <Link role="menuitem" tabIndex={-1} to="" style={{ display: "block", padding: "8px 12px", color: "#065f46", fontWeight: 700, textDecoration: "none" }}>
                                            Approved
                                          </Link>
                                        </li>
                                        <li
                                          role="presentation"
                                          onClick={() => {
                                            const confirmDelete = window.confirm("Are you sure you want to Reject");
                                            if (confirmDelete) aglist("2", host._id);
                                          }}
                                          style={{ borderRadius: 8 }}
                                        >
                                          <Link role="menuitem" tabIndex={-1} to="" style={{ display: "block", padding: "8px 12px", color: "#7f1d1d", fontWeight: 700, textDecoration: "none" }}>
                                            Reject
                                          </Link>
                                        </li>
                                      </>
                                    ) : host.status === "1" ? (
                                      <></>
                                    ) : null}
                                  </ul>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div style={{ marginTop: 14, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                  <div style={{ fontSize: 12, color: "#475569" }}>
                    Page <strong>{page}</strong>
                  </div>
                  <ul className="pagination" style={{ margin: 0, display: "flex", alignItems: "center", listStyle: "none", padding: 0 }}>
                    <li>
                      <span
                        style={pagerBtn(page <= 1)}
                        onClick={() => {
                          if (page > 1) setPage((prev) => Math.max(prev - 1, 1));
                        }}
                      >
                        Previous
                      </span>
                    </li>
                    <li>
                      <span style={pagerBtn(false)} onClick={() => setPage((prev) => prev + 1)}>
                        Next
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div style={{ height: 4, width: "100%", background: "linear-gradient(90deg, rgba(52,152,219,0.25), rgba(99,102,241,0.25))", borderRadius: 999, marginTop: 10, animation: "pulseSoft 2.6s ease-in-out infinite" }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default HostList;
